import * as React from 'react';

import BaseSalesListLayout from './BaseSalesListLayout';
import CreateSale from "~/apps/pos/mobile/containers/sales/CreateSale";

export default function ({ saleId, step }) {
  return BaseSalesListLayout(
    <div className="ol__cont ol--cent">
      <div className="card">
        <CreateSale isDesktop={true} isAgent={true} saleId={saleId} step={step} />
      </div>
    </div>
  );
};
